import React, { useState } from 'react';
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';
import { Link } from 'react-router-dom';
import '../css/ForgotPassword.css';
import('../css/Footer.css')
import('../css/Navbar.css')

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleForgotPassword = (e) => {
        e.preventDefault();

        // Simulate a password reset action
        if (email) {
            setMessage(`A password reset link has been sent to ${email}`);
            setEmail(''); // Reset email field
        } else {
            setMessage('Please enter a valid email address.');
        }
    };

    return (
        <>
            <NavbarComponent />
            <div className="forgot-password-container">
                <h2>Forgot Password</h2>
                <form className="forgot-password-form" onSubmit={handleForgotPassword}>
                    <div className="form-group-forgot">
                        <label htmlFor="email">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            placeholder="Enter your registered email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="forgot-password-button">
                        Send Reset Link
                    </button>
                    {message && <p className="message">{message}</p>}
                </form>
                <div className="back-to-signin">
                    <Link to="/login">Back to Sign In</Link>
                </div>
            </div>
            <FooterComponent />
        </>
    );
};

export default ForgotPassword;
